import { SVGProps } from 'react';

export const MegaphoneIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}>
    <path
      d='M6.89362 10.5599C6.43435 10.5202 5.96954 10.5 5.5 10.5H5C3.34315 10.5 2 9.15685 2 7.5C2 5.84314 3.34315 4.5 5 4.5H5.5C5.96954 4.5 6.43436 4.47977 6.89362 4.44015M6.89362 10.5599C7.06219 11.201 7.28248 11.8212 7.54976 12.4156C7.71473 12.7825 7.58948 13.2218 7.24107 13.423L6.80353 13.6756C6.43594 13.8878 5.96373 13.7537 5.78561 13.3684C5.36786 12.4649 5.0436 11.5093 4.82524 10.514M6.89362 10.5599C6.63678 9.583 6.5 8.55747 6.5 7.5C6.5 6.44252 6.63678 5.417 6.89362 4.44015M6.89362 10.5599C8.99998 10.7416 10.9896 11.3314 12.7831 12.2499M6.89362 4.44015C8.99998 4.2584 10.9896 3.66855 12.7831 2.75006M12.7831 2.75006C12.7047 2.4973 12.6201 2.24722 12.5296 2M12.7831 2.75006C13.1398 3.89885 13.3705 5.10308 13.4591 6.34661M12.7831 12.2499C12.7047 12.5027 12.6201 12.7528 12.5296 13M12.7831 12.2499C13.1398 11.1012 13.3705 9.89692 13.4591 8.65339M13.4591 6.34661C13.7896 6.62176 14 7.03631 14 7.5C14 7.96369 13.7896 8.37824 13.4591 8.65339M13.4591 6.34661C13.4862 6.72754 13.5 7.11216 13.5 7.5C13.5 7.88784 13.4862 8.27246 13.4591 8.65339'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
